import { useEffect } from 'react';

// Holder skjermen våken mens `active` er sann (Screen Wake Lock API). Nettleseren slipper
// låsen når siden skjules, så den hentes på nytt når sjåføren kommer tilbake til appen.
// Gjør ingenting i nettlesere uten støtte.
export function useWakeLock(active) {
  useEffect(() => {
    if (!active || !('wakeLock' in navigator)) return;

    let lock = null;
    let cancelled = false;

    async function acquire() {
      if (document.visibilityState !== 'visible') return;
      try {
        const next = await navigator.wakeLock.request('screen');
        if (cancelled) { next.release().catch(() => {}); return; }
        lock = next;
      } catch {
        // Kan avvises, f.eks. ved lavt batteri — sporingen fungerer da som før
      }
    }

    function onVisibilityChange() {
      if (document.visibilityState === 'visible' && (!lock || lock.released)) acquire();
    }

    acquire();
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVisibilityChange);
      lock?.release().catch(() => {});
    };
  }, [active]);
}
